import moment from 'moment';
import { COUNTRY, DATE_FORMAT } from '../../constants'

export const getPageDescriptionBody = (pageDescription) => {
    return {
        skip: pageDescription.skip,
        limit: pageDescription.limit,
        sorted: pageDescription.sorted
    }
}

export const setRequestBody = (productType, statusType, country, selectedCorporate, date, searchText) => {
    const tempCorporate = [];
    selectedCorporate.forEach(data => {
        tempCorporate.push(data.value)
    })

    return {
        searchText: searchText ? searchText : null,
        corporateIdList: tempCorporate,
        fromDate: (date.fromDate) ? moment(date.fromDate).format() : null,
        toDate: (date.toDate) ? moment(date.toDate).format() : null,
        productType: productType ? productType.label : null,
        statusType: statusType ? statusType.label : null,
        country: country ? { countryCode: getCountryCode(country.label), countryName: country.label } : null
    }
}

const getCountryCode = (countryName) => {
    let tempCountryCode = '';
    COUNTRY.map(c => {
        if (c.countryName === countryName) {
            tempCountryCode = c.countryCode;
        }
    });
    return tempCountryCode;
}

export const setAppliedFilters = (productType, statusType, country, selectedCorporate, date) => {
    let tempSelectedFilters = []
    selectedCorporate.forEach(item => {
        tempSelectedFilters.push(item);
    });
    if (date.toDate && date.fromDate) {
        tempSelectedFilters.push({ label: (moment(date.fromDate).format(DATE_FORMAT) + ' to ' + moment(date.toDate).format(DATE_FORMAT)), value: 'date' })
    }
    if (productType) {
        tempSelectedFilters.push({ label: productType.label, value: 'productType' });
    }
    if (statusType) {
        tempSelectedFilters.push({ label: statusType.label, value: 'statusType' });
    }
    if (country) {
        tempSelectedFilters.push({ label: country.label, value: 'country' });
    }
    return tempSelectedFilters
}

export const createFilterUrl = (productType, statusType, country, date, selectedCorporates) => {
    let url = new URLSearchParams();
    if (productType) {
        url.set('productType', encodeURIComponent(productType.label));
    }
    if (statusType) {
        url.set('statusType', encodeURIComponent(statusType.label));
    }
    if (country) {
        url.set('country', encodeURIComponent(country.label));
    }
    if (date.fromDate && date.toDate) {
        url.set("dateRange", encodeURIComponent(moment(date.fromDate).format(DATE_FORMAT) + 'to' + moment(date.toDate).format(DATE_FORMAT)));
    }
    if (selectedCorporates.length > 0) {
        url.set('corporates', JSON.stringify(selectedCorporates));
    }
    return decodeURIComponent(url)
}

export const getUrlFilter = (urlFilter) => {
    const params = new URLSearchParams(urlFilter);
    const tempFilters = {
        fromDate: params.get('dateRange') ? params.get('dateRange').split('to')[0] : null,
        toDate: params.get('dateRange') ? params.get('dateRange').split('to')[1] : null,
        productType: params.get('productType') ? { label: params.get('productType'), value: 'productType' } : undefined,
        statusType: params.get('statusType') ? { label: params.get('statusType'), value: 'statusType' } : undefined,
        selectedCorporates: params.get('corporates') ? JSON.parse(params.get('corporates')) : [],
        country: params.get('country') ? { label: params.get('country'), value: 'country' } : undefined,

    };
    return tempFilters
}